import { Skeleton, useMediaQuery, useTheme } from "@mui/material";
import { BoxDetailContainer, BoxRow } from "@src/pages/componentGroupOverview/components/articleHeader/ArticleHeaderSkeleton.styles";
import { type FunctionComponent } from "react";

import { BoxColumn, BoxContainer, BoxContent, BoxGrid, BoxImage, BoxModelDetails, BoxPerfectFit, BoxVerticalSeparator } from "./ArticleHeader.styles";

export const ArticleHeaderSkeleton: FunctionComponent = ({ ...restProps }) => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

    return (
        <BoxContainer {...restProps}>
            <BoxGrid>
                <BoxContent>
                    <BoxModelDetails>
                        <BoxImage>
                            <Skeleton height={80} width="100%" />
                        </BoxImage>

                        <BoxDetailContainer>
                            <Skeleton height={20} width={50} />

                            <Skeleton height={20} width={280} />

                            <Skeleton height={20} width={180} />
                        </BoxDetailContainer>
                    </BoxModelDetails>

                    <BoxPerfectFit>
                        {!isSmallScreen && <BoxVerticalSeparator />}

                        <BoxColumn>
                            <Skeleton width={204} height={20} />

                            <BoxRow>
                                <Skeleton width={110} height={20} />

                                <Skeleton width={110} height={20} />
                            </BoxRow>
                        </BoxColumn>
                    </BoxPerfectFit>
                </BoxContent>
            </BoxGrid>
        </BoxContainer>
    );
};
